import {Component, ComponentInterface, h, Host, Prop} from '@stencil/core';
import {SolIconSize, SolIconSizeEnum} from '../sol-icon/types/sol-icon-sizes';
import type {SolIconNames} from './types/sol-icon-names';

// TODO Use material icon instead of custom icon

@Component({
  tag: 'sol-icon',
  styleUrl: 'sol-icon.scss',
  assetsDirs: ['assets', 'fonts'],
})
export class SolIcon implements ComponentInterface {
  @Prop()
  icon?: SolIconNames;

  @Prop()
  size?: SolIconSize = SolIconSizeEnum.s24;

  render() {
    return <Host class={`sol-icon sol-icon-${this.icon} sol-icon--size-${this.size}`} />;
  }
}
